import { observer } from 'mobx-react-lite'
import { type FC } from 'react'
import { Button } from 'shared/ui'
import { type PhoneCheckrStore } from 'pages/settings/ui/PhoneCheckr'

type IPhoneCheckFirstModalActionsProps = {
  store: PhoneCheckrStore
}

export const PhoneCheckFirstModalActions: FC<IPhoneCheckFirstModalActionsProps> = observer(
  ({ store }) => {
    const { closeModal, openSecondModal } = store
    return (
      <>
        <Button
          typeBtn='contained'
          text='Cancel'
          size='medium'
          contained='secondary'
          onClick={closeModal}
        />
        <Button typeBtn='contained' text='Continue' size='medium' onClick={openSecondModal} />
      </>
    )
  }
)
